import {PROTOCOL_SLIDE_TYPES} from '@learningblocks/protocol-constants/lib/Utilities';

export function slideThreeApplyHint(state) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection),
  };
}

function updateDesignSection(protocolSection) {
  const updateInSlide = (slide) => {
    if (slide.type === PROTOCOL_SLIDE_TYPES.THREE) {
      slide = updateSlideThree(slide);
    }
    return slide;
  };

  return {
    ...protocolSection,
    allSlides: protocolSection.allSlides.map(updateInSlide),
  };
}

function updateSlideThree(slide) {
  let {groups: slideTree, hintsUsed} = slide.slideTree.reduce(
    (resp, group) => {
      if (resp.updated === false) {
        group.groupNodes = group.groupNodes.map((groupNode) => {
          if (resp.updated === false && groupNode.droppedId === null) {
            groupNode.droppedId = groupNode.nodeId;
            resp.updated = true;
            resp.hintsUsed += 1;
          }
          return groupNode;
        });
      }
      resp.groups = [...resp.groups, group];
      return resp;
    },
    {updated: false, groups: [], hintsUsed: slide.hintsUsed}
  );
  return {
    ...slide,
    hintsUsed,
    slideTree,
  };
}
